import addressCountryFormatter from '../addressCountryFormatter';

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (r, fn) {
      return fn(r);
    }, v);
  };
};
/**
 * @param {{ full: string }} [place]
 * @returns {Array<string>}
 */


export default function addressFormatter() {
  var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var countryCode = arguments.length > 1 ? arguments[1] : undefined;
  var splitSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  return pipe(function (_ref) {
    var full = _ref.full,
        inp = _ref.place;
    return full || function (_ref2) {
      var xf = _ref2.full;
      return xf;
    }(inp || {});
  }, function (adr) {
    return addressCountryFormatter(adr, countryCode, splitSeparator, '|');
  }, function (adr) {
    return !adr ? [] : adr.split('|');
  })(place);
}